import { style, media } from 'typestyle'
import { important } from 'csx'
export const pl16mdi = style(media({ maxWidth: 768 }, { paddingLeft: important('16px') }))
